// extracted by mini-css-extract-plugin
export var card = "_mk-0";
export var content = "_mk-2";
export var details = "_mk-3";
export var icon = "_mk-1";
export var iconBlue = "_mk-5";
export var iconBrand = "_mk-4";
export var iconGrayBlue = "_mk-6";
export var iconGreen = "_mk-7";
export var iconIndigo = "_mk-8";
export var iconOrange = "_mk-9";
export var iconPurple = "_mk-a";
export var iconRed = "_mk-b";
export var iconWarning = "_mk-c";